import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';

// ============================================
// Overlay & Card
// ============================================
export const ModalOverlay = styled(Box, {
  shouldForwardProp: prop => prop !== 'open',
})(({ open }) => ({
  zIndex: 100,
  position: 'fixed',
  top: 0,
  left: 0,
  height: '100%',
  width: '100%',
  display: open ? 'flex' : 'none',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
}));

export const ModalCard = styled(Box)({
  minWidth: '400px',
  minHeight: '200px',
  borderRadius: '15px',
  border: '1px solid #00000010',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-around',
  background: '#fff',
  padding: '20px',
});

// ============================================
// Message
// ============================================
export const MessageWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginTop: '18px',
  width: '100%',
  justifyContent: 'center',
});

export const MessageText = styled(Typography)({
  fontWeight: 600,
  fontSize: '20px',
  lineHeight: '17px',
  textAlign: 'center',
  color: 'firebrick',
});

// ============================================
// Buttons
// ============================================
export const ButtonContainer = styled(Box)({
  marginTop: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  width: '100%',
});

export const CancelButton = styled(Button)({
  padding: '12px 37px 11px 37px',
  borderRadius: '5px',
  height: '36px',
  width: '100px',
  background: '#98A6AD',
  color: '#fff',
  '&:hover': {
    background: '#ddd',
  },
});

export const DeleteButton = styled(Button)({
  padding: '12px 56px 11px 55px',
  borderRadius: '5px',
  height: '36px',
  width: '137px',
  background: '#1F3A5F',
  color: '#fff',
  marginLeft: '16px',
  '&:hover': {
    background: '#1F3A5F',
    color: '#fff',
  },
});
